import { render, staticRenderFns } from "./ChatbotDebugMessage.vue?vue&type=template&id=2623d7aa"
import script from "./ChatbotDebugMessage.vue?vue&type=script&lang=js"
export * from "./ChatbotDebugMessage.vue?vue&type=script&lang=js"
import style0 from "./ChatbotDebugMessage.vue?vue&type=style&index=0&id=2623d7aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports